// src/sections/admin/ServicesSection.js
import React, { useState } from 'react';
import axios from 'axios';
import ResourceTable from '../../components/admin/ResourceTable';
import ServiceForm from '../../components/admin/ServiceForm';

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const ServicesSection = ({ user, services = [], setMsg, fetchAll }) => {
  const [showForm, setShowForm] = useState(false);
  const [editingService, setEditingService] = useState(null);

  const adminTenantId = user?.tenant_id != null ? parseInt(user.tenant_id, 10) : null; 

  const serviceColumns = [
    { key: 'id', label: 'ID' },
    { key: 'name', label: 'Service Name' },
    { key: 'prefix', label: 'Prefix' },
    { key: 'tenant_id', label: 'Tenant ID' }
  ];

  const handleAddService = () => {
    setEditingService(null); 
    setShowForm(true);
  };

  const handleEditService = (serviceData) => {
    setEditingService(serviceData);
    setShowForm(true);
  };

  const handleDeleteService = async (serviceData) => {
    if (window.confirm(`Are you sure you want to delete service ${serviceData.name}?`)) {
      try {
        await axios.delete(`${BASE_URL}/api/services/${serviceData.id}`);
        setMsg({ type: 'success', text: `Service ${serviceData.name} deleted successfully!` });
        fetchAll(); 
      } catch (error) {
        setMsg({ type: 'error', text: `Failed to delete service: ${error.message}` });
        console.error("Error deleting service:", error);
      }
    }
  };

  const handleSubmitServiceForm = async (formData, isEditMode) => {
    try {
      const dataToSubmit = { ...formData };
      if (isEditMode) {
        await axios.patch(`${BASE_URL}/api/services/${formData.id}`, dataToSubmit);
        setMsg({ type: 'success', text: `Service ${formData.name} updated successfully!` });
      } else {
        dataToSubmit.tenant_id = adminTenantId;
        await axios.post(`${BASE_URL}/api/services`, dataToSubmit);
        setMsg({ type: 'success', text: `Service ${formData.name} added successfully!` });
      }
      setShowForm(false);
      setEditingService(null);
      fetchAll();
    } catch (error) {
      setMsg({ type: 'error', text: `Failed to ${isEditMode ? 'update' : 'add'} service: ${error.message}` });
      console.error("Error submitting service form:", error);
    }
  };

  let filteredServices = services;
  if (user?.role === 'vendor_admin' || String(user?.tenant_id) === '999') {
    filteredServices = services;
  } else {
    filteredServices = services.filter(s => String(s.tenant_id) === String(adminTenantId));
  }

  return (
    <div>
      <h2 className="admin-section-header">Service Management</h2>
      {!showForm ? (
        <>
          <button onClick={handleAddService} className="admin-button primary" style={{ marginBottom: '1.5rem' }}>Add New Service</button>
          <ResourceTable 
            data={filteredServices} 
            columns={serviceColumns} 
            onEdit={handleEditService} 
            onDelete={handleDeleteService} 
            title="Services"
          />
        </>
      ) : (
        <ServiceForm 
          user={user} 
          initialData={editingService || {}} 
          onSubmit={handleSubmitServiceForm} 
          onCancel={() => setShowForm(false)} 
        />
      )}
    </div>
  );
};

export default ServicesSection;